// extracted by mini-css-extract-plugin
module.exports = {"quantitySelect":"_7634d8a6"};